import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MeteringPointService, RequestMasterDataDto } from '@app/api/dmc';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { InputDirective } from '@shared/components/input/input/input.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { FormApiService } from '@app/core/services/form-api.service';
import { isoToRealDate } from '@app/core/utils/iso-to-real-date';
import { HasUnsavedChanges } from '@app/core/guards/unsaved-changes.guard';

@Component({
  selector: 'app-root-modal',
  imports: [
    ReactiveFormsModule,
    InputGroupComponent,
    LabelDirective,
    InputDirective,
    TranslatePipe,
  ],
  templateUrl: './root-modal.component.html',
  styleUrl: './root-modal.component.css'
})
export class RootModalComponent implements OnInit, HasUnsavedChanges{
  public hasUnsavedChanges(): boolean {
    return this.form.dirty;
  }

  public form: FormGroup = new FormGroup({
    validFrom: new FormControl<string | null>(null, Validators.required),
    meteringPointIdentification: new FormControl<string | null>(null, Validators.required),
  });

  public knownMeteringPoint = false;

  /** ID **/
  public id?: string;

  constructor(
    private readonly meteringPointService: MeteringPointService,
    private readonly formApiService: FormApiService,
  ) { }

  public ngOnInit(): void {
    if (this.id) {
      this.form.get('meteringPointIdentification')?.setValue(this.id);
      this.knownMeteringPoint = true;
    } else {
      this.knownMeteringPoint = false;
    }

    this.form.get('validFrom')?.setValue(isoToRealDate(new Date()));
  }

  public submit(): void {
    /** Form ApiService **/
    this.formApiService.submit<RequestMasterDataDto>(
      this.form,
      (data) => this.knownMeteringPoint
        ? this.meteringPointService.meteringPointRequestMasterDataPost(data)
        : this.meteringPointService.meteringPointRequestMasterDataForUnknownPost(data),
      {
        successMessage: 'Anmodning om stamdata sendt',
        closeModal: true
      },
    );
  }
}
